<template>
  <div class="teacher_wrap">
    <headerBlack-view></headerBlack-view>
    <div class="search flex-align-between" style="display:none">
      <input type="text" placeholder="请输入关键字查询" />
      <div class="search_btn flex-align-around">
        <div class="flex-align">
          <img src="@/assets/teacher/search.png" />
          <span>搜索</span>
        </div>
      </div>
    </div>
    <div class="classify_wrap flex-column-between" style="display:none">
      <div class="classify_project flex-align">
        <div class="classify_title">按项目分类:</div>
        <div class="classify_item">全部</div>
        <div class="classify_item">首都教育远程互助工程</div>
        <div class="classify_item">双优云桥-银川</div>
        <div class="classify_item">首师学苑</div>
        <div class="classify_item">乐智学堂</div>
      </div>
      <div class="classify_job flex-align">
        <div class="classify_title">按职称分类:</div>
        <div class="classify_item">全部</div>
        <div class="classify_item">教授</div>
        <div class="classify_item">副教授</div>
        <div class="classify_item">讲师</div>
        <div class="classify_item">助教</div>
      </div>
    </div>
    <div class="teacher_list flex-align-wrap" style="margin-top:30px;margin-bottom:50px">
      <div class="teacher_item" :class="{'teacher_item2':(index+1)%2==0}" v-for="(item,index) in tealist" :key=index
        @click="goDetail(item.id)">
        <div class="photo_bg"></div>
        <div class="teacher_info flex-layout">
          <div class="teacher_photo">
            <img :src="item.image" />
          </div>
          <div class="teacher_introduce">
            <div class="introduce_name flex-layout">
              <span class="name">{{item.name}}</span>
              <span class="post">{{item.title}}</span>
            </div>
            <div class="introduce_project flex-align-around">{{item.ascriptionName}}</div>
            <div class="introduce_content">
              {{item.instruction}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="more">查看更多</div> -->
    <footer-view></footer-view>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tealist: []
      }
    },
    methods: {
      async getTealist() {
        let param = {
          type: 1
        }
        let resData = await Api.Teacher.gettealist(param)
        console.log(resData)
        this.tealist = resData.rows
      },
      goDetail(id) {
        Common.goPage(`/teacher_detail/${id}`, this)
      }
    },
    mounted() {
      this.getTealist()
    }
  };
</script>

<style lang="less">
  @import "./teacher_list.less";
</style>